module.exports = __webpack_public_path__ + "img/logo.b123c879.png";